module.exports = __webpack_public_path__ + "static/burlingame-805c93815851bdd3aa344a908c01a3d4.jpg";